import React from 'react';
import Button from '../../shared/Button';
import { useDownload } from '../../../hooks/reports/useDownload';

const DownloadButton = ({ reportData }) => {
  const { isDownloading, error, download } = useDownload();

  const handleDownload = () => {
    download(reportData);
  };

  return (
    <>
      <Button
        onClick={handleDownload}
        disabled={isDownloading}
        variant="primary"
        className="download-btn"
      >
        {isDownloading ? (
          <>
            <span className="spinner"></span>
            Generating PDF...
          </>
        ) : (
          <>📄 Download PDF</>
        )}
      </Button>
      {error && <div className="error-message">{error}</div>}
    </>
  );
};

export default DownloadButton;
